// Year / Make / Model of every car AdminTuning offers tuning for (US model years).
// [make, model, first year, last year, platform, model id] — platform keys match assets/fitment.js and the tune builder:
// vq35 = VQ35DE/HR (2003–2008) · g37_08 = 2008 G37 (VQ37VHR, early ECU, UpRev) · vq37 = VQ37VHR (2009+) ·
// vr30 = VR30DDTT · z = 2023+ Nissan Z · gtr = VR38DETT · bmw = BMW B58 / S58 (DME unlock & flex fuel).
// Model id = one exact car: a part can list model ids in assets/fitment.js instead of a whole platform (owner 2026-11-01:
// per-model fitment for the VQ parts, e.g. the 3" intakes fit the 2007–2008 G35 sedan but not the Q50 3.7 or the 350Z).
// The 350Z / G35 rows are split by engine: VQ35DE to 2006 (G35 coupe to 2007), VQ35HR 2007–2008.
// On Shopify this list becomes a metaobject or a JSON setting the owner can edit.
window.AT_YMM = [
  ["Nissan", "350Z", 2003, 2006, "vq35", "350z_de"],
  ["Nissan", "350Z", 2007, 2008, "vq35", "350z_hr"],
  ["Nissan", "370Z", 2009, 2020, "vq37", "370z"],
  ["Nissan", "GT-R", 2009, 2024, "gtr", "gtr"],
  ["Nissan", "Z", 2023, 2026, "z", "z"],
  ["Infiniti", "G35 Coupe", 2003, 2007, "vq35", "g35c"],
  ["Infiniti", "G35 Sedan", 2003, 2006, "vq35", "g35s_de"],
  ["Infiniti", "G35 Sedan", 2007, 2008, "vq35", "g35s_hr"],
  ["Infiniti", "G37 Coupe", 2008, 2008, "g37_08", "g37c_08"],
  ["Infiniti", "G37 Coupe", 2009, 2013, "vq37", "g37c"],
  ["Infiniti", "G37 Sedan", 2009, 2013, "vq37", "g37s"],
  ["Infiniti", "G37 Convertible", 2009, 2013, "vq37", "g37v"],
  ["Infiniti", "M37", 2011, 2013, "vq37", "m37"],
  ["Infiniti", "Q40", 2015, 2015, "vq37", "q40"],
  ["Infiniti", "Q50 3.7", 2014, 2015, "vq37", "q50_37"],
  ["Infiniti", "Q50 3.0T / Red Sport 400", 2016, 2024, "vr30", "q50_30t"],
  ["Infiniti", "Q60 3.7", 2014, 2015, "vq37", "q60_37"],
  ["Infiniti", "Q60 3.0T / Red Sport 400", 2017, 2022, "vr30", "q60_30t"],
  ["Infiniti", "Q70 3.7", 2014, 2019, "vq37", "q70"],
  // VQ-based Infiniti SUVs, 2004–2017 (no JX35 / QX60). suv35 = 2004–2008 ECU · suv37 = 2009+ ECU
  ["Infiniti", "FX35", 2004, 2008, "suv35", "fx35_08"],
  ["Infiniti", "FX35", 2009, 2012, "suv37", "fx35"],
  ["Infiniti", "FX37", 2013, 2013, "suv37", "fx37"],
  ["Infiniti", "QX70 3.7", 2014, 2017, "suv37", "qx70"],
  ["Infiniti", "EX35", 2008, 2008, "suv35", "ex35_08"],
  ["Infiniti", "EX35", 2009, 2012, "suv37", "ex35"],
  ["Infiniti", "EX37", 2013, 2013, "suv37", "ex37"],
  ["Infiniti", "QX50 3.7", 2014, 2017, "suv37", "qx50"],
  ["Toyota", "GR Supra 3.0 (B58)", 2020, 2026, "bmw", "supra"],
  ["BMW", "M3 (G80, S58)", 2021, 2026, "bmw", "m3"],
  ["BMW", "M4 (G82/G83, S58)", 2021, 2026, "bmw", "m4"],
  ["BMW", "X3 M (F97, S58)", 2020, 2024, "bmw", "x3m"]
];
window.AT_PLATFORM = { vq35: "VQ35DE / VQ35HR", g37_08: "VQ37VHR · 2008 ECU (UpRev)", vq37: "VQ37VHR", vr30: "VR30DDTT", z: "VR30DDTT (RZ34)", gtr: "VR38DETT", bmw: "BMW B58 / S58",
  suv35: "VQ35 SUV · 2004–2008 ECU", suv37: "VQ SUV · 2009+ ECU (VQ35HR / VQ37VHR)" };
